module.exports = __webpack_public_path__ + "media/images/ep2-cindy-7bc49b21ef7273a5f0073985cef6c4d5.jpg";